import { Box, Button, Collapse, List, ListItemButton, ListItemText, Checkbox } from "@mui/material";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
// import ArgonBox from "components/ArgonBox";
import PropTypes from "prop-types";
import MDInput from "components/MDInput";
import { useMaterialUIController } from "context";

function useOutsideClosing(ref, setLocationSearchSwitch) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setLocationSearchSwitch(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mouseup", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, [ref]);
}

const ApnaSelect2 = ({
  data,
  value,
  name,
  onChange,
  origin,
  valueKey,
  nameKey,
  isSimpleArray,
  isMulti,
  hideSearch = false,
  ...rest
}) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [openDropDown, setOpenDropDown] = useState(false);
  const [valueName, setValueName] = useState("");
  const [search, setSearch] = useState("");
  const outSideClose = useRef(null);
  useOutsideClosing(outSideClose, setOpenDropDown);

  const filterData = useMemo(() => {
    if (search && data && data?.length) {
      if (!isSimpleArray)
        return data?.filter((e) => e[nameKey]?.toLowerCase()?.includes(search?.toLowerCase()));
      else if (isSimpleArray)
        return data?.filter((e) => e?.toLowerCase()?.includes(search?.toLowerCase()));
      else return [];
    }
  }, [search, data, isSimpleArray, nameKey]);

  useEffect(() => {
    if (isMulti) {
      if (!isSimpleArray && data && data?.length && Array.isArray(value)) {
        const selected = data
          .filter((e) => value.map((v) => String(v)).includes(String(e[valueKey])))
          .map((e) => e[nameKey]);
        setValueName(selected.length > 0 ? selected.join(", ") : "");
      } else {
        setValueName("");
      }
    } else {
      if (!isSimpleArray && data && data?.length) {
        const item = data?.find(
          (e) =>
            value !== undefined &&
            value !== null &&
            value !== "" &&
            String(e[valueKey]) === String(value)
        );
        if (item) setValueName(item[nameKey]);
        else setValueName("");
      }
    }
  }, [value, data, isMulti, isSimpleArray, valueKey, nameKey]);

  const handleClick = () => {
    setOpenDropDown(!openDropDown);
    setSearch("");
  };

  const handleSelectOption = (elm) => {
    if (isMulti) {
      const currentValues = Array.isArray(value) ? value : [];
      const itemVal = isSimpleArray ? elm : elm[valueKey];
      const exists = currentValues.includes(itemVal);
      const newValues = exists
        ? currentValues.filter((v) => v !== itemVal)
        : [...currentValues, itemVal];
      onChange({
        target: {
          name,
          value: newValues,
        },
      });
    } else {
      onChange(
        isSimpleArray
          ? name
          : {
              target: {
                name,
                value: elm[valueKey],
                fullObject: elm,
              },
            }
      );
      handleClick();
    }
  };

  const displayList = search ? filterData : data;

  return (
    <>
      <div style={{ marginBottom: "10px", width: "100%" }} ref={outSideClose}>
        <List>
          <ListItemButton
            {...rest}
            sx={{
              borderRadius: "10px",
              border: "1px solid gainsboro",
              padding: ".575rem 1.125rem",
              position: "relative",
              zIndex: "100",
            }}
            onClick={handleClick}
          >
            <ListItemText
              sx={({ palette: { dark, error, info, white } }) => ({
                "& .MuiTypography-root": {
                  fontWeight: "500",
                  fontSize: "14px",
                  color: !darkMode ? dark.main : white.main,
                },
              })}
              primary={isSimpleArray ? name : valueName ? valueName : `Choose ${origin}`}
            />
            {openDropDown ? (
              <ExpandLess color={!darkMode ? "primary" : "white"} />
            ) : (
              <ExpandMore color={!darkMode ? "primary" : "white"} />
            )}
          </ListItemButton>
          <Checkbox
            {...rest}
            sx={{ display: "none" }}
            checked={valueName ? true : false}
          />
          <Collapse
            sx={({ palette: { dark, error, info, white } }) => ({
              "& .MuiCollapse-wrapper": {
                height: "40%",
                overflowY: "scroll",
              },
              backgroundColor: darkMode ? dark.main : white.main,
            })}
            style={{
              position: "absolute",
              width: "100%",
              border: "1px solid Silver",
              margin: "0.5rem 0",
              zIndex: "1000",
              borderRadius: "12px",
              padding: "2% ",
            }}
            in={data && data.length && openDropDown}
            timeout="auto"
          >
            <List sx={{ position: "relative" }} component="div" disablePadding>
              {!hideSearch && (
                <>
                  <Box
                    sx={({ palette: { dark, error, info, white } }) => ({
                      position: "sticky",
                      top: "0",
                      backgroundColor: darkMode ? dark.main : white.main,
                      zIndex: "1000",
                      "& .MuiListItemText-root": {
                        color: !darkMode ? dark.main : white.main,
                      },
                    })}
                  >
                    <ListItemText
                      sx={({ palette: { dark, error, info, white } }) => ({
                        display: "block",
                        "& .MuiTypography-root": {
                          fontWeight: "500",
                          fontSize: "14px",
                          color: !darkMode ? dark.main : white.main,
                        },
                      })}
                      primary={"Search"}
                    />
                    <ListItemButton onClick={() => {}} sx={{ pl: 1 }}>
                      <MDInput
                        fullWidth
                        className="form-control"
                        type="text"
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                      />
                    </ListItemButton>
                  </Box>
                  <hr />
                </>
              )}
              {displayList && displayList.length > 0 ? (
                displayList.map((elm, i) => {
                  const itemVal = isSimpleArray ? elm : elm[valueKey];
                  const isChecked = isMulti
                    ? Array.isArray(value) && value.includes(itemVal)
                    : value === itemVal;

                  return (
                    <ListItemButton
                      onClick={() => handleSelectOption(elm)}
                      key={i}
                      sx={{ pl: 1, fontSize: "1rem", display: "flex", alignItems: "center", gap: 1 }}
                    >
                      {isMulti && (
                        <Checkbox
                          checked={!!isChecked}
                          size="small"
                          sx={{ p: 0 }}
                        />
                      )}
                      <ListItemText
                        sx={({ palette: { dark, error, info, white } }) => ({
                          "& .MuiTypography-root": {
                            fontWeight: isChecked ? "600" : "400",
                            fontSize: "14px",
                            color: !darkMode ? dark.main : white.main,
                          },
                        })}
                        primary={isSimpleArray ? elm : elm[nameKey]}
                      />
                    </ListItemButton>
                  );
                })
              ) : (
                <ListItemButton
                  onClick={() => handleClick()}
                  sx={{ pl: 1 }}
                >
                  <ListItemText
                    sx={({ palette: { dark, error, info, white } }) => ({
                      "& .MuiTypography-root": {
                        color: !darkMode ? dark.main : white.main,
                      },
                    })}
                    primary={"Sorry No Data To Show"}
                  />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </List>
      </div>
    </>
  );
};

export default ApnaSelect2;

ApnaSelect2.propTypes = {
  data: PropTypes.any,
  value: PropTypes.any,
  name: PropTypes.any,
  onChange: PropTypes.any,
  origin: PropTypes.any,
  valueKey: PropTypes.any,
  nameKey: PropTypes.any,
  isSimpleArray: PropTypes.any,
  isMulti: PropTypes.bool,
  hideSearch: PropTypes.bool,
};
